import moment from 'moment';

export default function transformSoftwareUpdateFilters(filters = {}) {
  const newFilters = {};
  let filtersCount = 0;
  const { creationFilter, softwareType, updateStatus, creationGreaterThan, creationLesserThan } = filters;

  switch (creationFilter) {
    case 'customrange':
      newFilters.creationGreaterThan = creationGreaterThan;
      newFilters.creationLesserThan = creationLesserThan;
      filtersCount = 2;
      break;
    case 'today':
      filtersCount = 1;
      newFilters.creationGreaterThan = moment()
        .startOf('day')
        .toDate();
      break;
    case 'yesterday':
      filtersCount = 1;
      newFilters.creationGreaterThan = moment()
        .subtract(1, 'days')
        .toDate();
      newFilters.creationLesserThan = moment()
        .startOf('day')
        .toDate();
      break;
    case 'lastweek':
      filtersCount = 1;
      newFilters.creationGreaterThan = moment()
        .subtract(7, 'days')
        .toDate();
      break;
    case 'previousweek':
      filtersCount = 2;
      newFilters.creationGreaterThan = moment()
        .subtract(14, 'days')
        .toDate();
      newFilters.creationLesserThan = moment()
        .subtract(7, 'days')
        .toDate();
      break;
    case 'recentpackage':
      filtersCount = 1;
      newFilters.pageSize = 1;
      break;
    case 'recent10packages':
      filtersCount = 1;
      newFilters.pageSize = 10;
      break;
    case 'recent20packages':
      filtersCount = 1;
      newFilters.pageSize = 20;
      break;
    default:
  }

  if (softwareType && softwareType !== '') {
    newFilters.softwareTypeId = softwareType;
    filtersCount++;
  }
  if (updateStatus && updateStatus !== '') {
    newFilters.softwareUpdateStatusId = updateStatus;
    filtersCount++;
  }
  return newFilters;
}
